import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Button = ({
    children,
    variant = 'normal', // normal, gray
    disabled = false,
    onClick,
    type = 'button',
    size = 'medium', // medium, large
    narrow = false, // flex 컨테이너 안에서 내용 너비만 사용 (iOS WebView 등)
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    const baseStyles = {
        display: 'inline-flex',
        height: size === 'large' ? '60px' : '40px',
        padding: size === 'large' ? '10px 30px' : '10px 20px',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        borderRadius: size === 'large' ? '20px' : '15px',
        fontSize: size === 'large' ? '20px' : '16px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        textTransform: 'none',
        boxShadow: 'none',
        letterSpacing: size === 'large' ? '-0.6px' : '-0.48px',
        '&:hover': {
            boxShadow: 'none',
        },
        '&:focus': {
            boxShadow: 'none',
        },
        '&:disabled': {
            background: theme.palette.figma.white[10],
            color: theme.palette.figma.white[30],
        },
        ...sx,
    };

    const variantStyles = {
        normal: {
            background: `linear-gradient(90deg, ${theme.palette.figma.Red_didim} 0%, ${theme.palette.figma.buttonOrange} 100%)`,
            color: theme.palette.figma.buttonText,
        },
        gray: {
            background: theme.palette.figma.white[30],
            color: theme.palette.text.main,
        },
    };

    return (
        <MuiButton
            variant="contained"
            disabled={disabled}
            onClick={onClick}
            type={type}
            sx={{
                ...baseStyles,
                ...variantStyles[variant],
                ...(narrow && {
                    flex: '0 0 auto',
                    width: 'auto',
                    minWidth: 'unset',
                }),
            }}
            {...props}
        >
            {children}
        </MuiButton>
    );
};

export default Button;
